import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

window.Landing = require('../views/Landing.vue').default
window.Signin = require('../views/Signin.vue').default
window.Signup = require('../views/Signup.vue').default
window.Forgot = require('../views/Forgot.vue').default
window.Home = require('../views/Home.vue').default
window.StoryListView = require('../views/StoryListView.vue').default
//window.Timeline = require('../views/Timeline.vue').default
window.StoryEditView = require('../views/StoryEditView.vue').default
window.StoryEditView1 = require('../views/StoryEditView1.vue').default
window.simulation = require('../views/simulation.vue').default
window.logicEditView = require('../views/logicEditView.vue').default
window.globalLogicEditView = require('../views/globalLogicEditView.vue').default
window.mainStoryView = require('../views/mainStoryView.vue').default
window.Admin = require('../views/Admin.vue').default
window.Welcome = require('../views/Welcome.vue').default
window.Contact = require('../views/Contact.vue').default
window.FAQ = require('../views/FAQ.vue').default
window.Profile = require('../views/Profile.vue').default
window.Access = require('../views/Access.vue').default
window.Gallery = require('../views/Gallery.vue').default
window.Assets = require('../views/Assets.vue').default
window.UserClass = require('../views/UserClass.vue').default
// window.Visual = require('../views/Visual.vue').default
//window.Writer = require('../views/Writer.vue').default
window.NotFound = require('../views/NotFound.vue').default
window.Plans = require('../views/Plans.vue').default
window.Billing = require('../views/Billing.vue').default
window.Users = require('../views/Users.vue').default
window.SentVerification = require('../views/SentVerification.vue').default
window.ManageUsers = require('../views/ManageUsers.vue').default
window.AbxrMarket = require('../views/AbxrMarket.vue').default
window.AdminPanel = require('../views/AdminPanel.vue').default
window.Support = require('../views/Support.vue').default
window.Legal = require('../views/Legal.vue').default
window.Updates = require('../views/Updates.vue').default

const routes = [
  { path: '/', name: '', component: Landing },
  { 
    path: '/signin', name: 'signin', component: Signin, meta: { guest: true } },
  { path: '/signup', name: 'signup', component: Signup, meta: { guest: true } },
  { path: '/forgot', name: 'forgot', component: Forgot, meta: { guest: true } },
  //{path: '/home', name: 'home', component: Home, meta: {requiresAuth: true}},
  { path: '/storylist', name: 'storylist', component: StoryListView, meta: { requiresAuth: true } },
  { path: '/story/:title', name: 'storyview', component: StoryEditView, meta: { requiresAuth: true } },
  //{path: '/timeline/:title', name: 'timeline', component: Timeline, meta: {requiresAuth: true}},
  { path: '/storyEditView/:title', name: 'storyEditView', component: StoryEditView, meta: { requiresAuth: true } },
  { path: '/storyEditView', name: 'storyEditView', component: StoryEditView1, meta: { requiresAuth: true } },
  { path: '/simulation', name: 'simulation', component: simulation, meta: { requiresAuth: true } },
  { path: '/logicEditView', name: 'logicEditView', component: logicEditView, meta: { requiresAuth: true } },
  { path: '/mainStoryView', name: 'mainStoryView', component: mainStoryView, meta: { requiresAuth: true } },
  { path: '/admin', name: 'admin', component: Admin, meta: { requiresAuth: true } },
  { path: '/welcome', name: 'welcome', component: Welcome },
  { path: '/contact', name: 'contact', component: Contact },
  { path: '/faq', name: 'faq', component: FAQ },
  {path: '/uikits', name: 'uikits', component: ()=> import('../views/UiKits.vue') },


  {
    path: '/home',
    name: 'home',
    component: require('../views/ProfileWrapper.vue').default,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'homePageX',
        component: require('../views/Home.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: '/profile',
        name: 'profile',
        // component: Profile,
        component: require('../views/user_profile/info/ownerInfo.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: '/user-email',
        name: 'user-email',
        // component: require('../views/UserEmail.vue').default,
        component: require('../views/user_profile/info/email.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: '/user-security',
        name: 'user-security',
        // component: require('../views/UserSecurity.vue').default,
        component: require('../views/user_profile/info/security.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: '/administration',
        name: 'administration',
        component: AdminPanel,
        meta: { requiresAuth: true }
      },
      {
        path: '/assets',
        name: 'assets',
        component: require('../views/assets/index.vue').default,
        // component: Assets,
        meta: { requiresAuth: true },
        children: [
          { 
              path: ':asset',
              name: 'assets',
              component: require('../views/assets/index.vue').default,
              // component: Assets,
              meta: { requiresAuth: true },
            }
        ]
      },
      {
        path: '/manage-users',
        name: 'manageUsers',
        component: ManageUsers,
        meta: { requiresAuth: true }
      },
      {
        path: '/userclass',
        name: 'userclass',
        component: UserClass,
        meta: { requiresAuth: true }
      },
      {
        path: '/abxr-market',
        name: 'abxr-market',
        component: AbxrMarket,
        meta: { requiresAuth: true }
      },
      {
        path: '/support',
        name: 'support',
        component: Support,
        meta: { requiresAuth: true }
      },
      {
        path: '/legal',
        name: 'legal',
        component: Legal,
        meta: { requiresAuth: true }
      },
      {
        path: '/updates',
        name: 'updates',
        component: Updates,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/globalLogicEditView',
    name: 'globalLogicEditView',
    component: globalLogicEditView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'globalLogicEditView',
        component: require('../components/v2/story-edit-view/global-logic-components/globalLogicList').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'add',
        name: 'addGlobalLogic',
        component: require('../components/v2/story-edit-view/global-logic-components/globalLogic').default,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/newprofile',
    name: 'newprofile',
    component: require('../views/ProfileWrapper.vue').default,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'user-profile',
        name: 'user-profile',
        component: require('../views/UserProfile.vue').default,
        meta: { requiresAuth: true }
      },

      {
        path: 'project-dashboard',
        name: 'project-dashboard',
        component: require('../views/ProjectDashboard.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'projects',
        name: 'projects',
        component: require('../views/StoryListView.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'company/plans',
        name: 'company-plans',
        // component: Plans,
        component: require('../views/user_profile/company/plans.vue').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'company/billing',
        name: 'company-billing',
        component: Billing,
        meta: { requiresAuth: true }
      },
      {
        path: 'company/company-info',
        name: 'company-info',
        component: require('../views/user_profile/company/companyInfo.vue').default,
        // component: require('../components/profile/CompanyInfo').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'company/owner-info',
        name: 'owner-info',
        component: require('../components/profile/OwnerInfo').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'comingsoon',
        name: 'comingsoon',
        component: require('../components/profile/ComingSoon').default,
        meta: { requiresAuth: true }
      },
      {
        path: 'add-story',
        name: 'add-story',
        component: require('../components/v2/add_story/add_story_wrapper').default,
        meta: { requiresAuth: true },
        children: [
          {
            path: 'step-1',
            name: 'add-story-step-1',
            component: require('../components/v2/add_story/step1').default,
            meta: { requiresAuth: true }
          },
          {
            path: 'step-2',
            name: 'add-story-step-2',
            component: require('../components/v2/add_story/step2').default,
            meta: { requiresAuth: true }
          }
        ]
      },
      {
        path: 'update-story',
        name: 'update-story',
        component: require('../components/v2/update_story/update_story_wrapper').default,
        meta: { requiresAuth: true },
        children: [
          {
            path: 'step-1',
            name: 'update-story-step-1',
            component: require('../components/v2/update_story/step1').default,
            meta: { requiresAuth: true }
          },
          {
            path: 'step-2',
            name: 'update-story-step-2',
            component: require('../components/v2/update_story/step2').default,
            meta: { requiresAuth: true }
          }
        ]
      }
    ]
  },

  // { path: '/access', name: 'access', component: Access },
  { path: '/gallery', name: 'gallery', component: Gallery },
  // { path: '/visual', name: 'visual', component: Visual, meta: { requiresAuth: true } },
  // { path: '/writer', name: 'writer', component: Writer, meta: { requiresAuth: true } },
  { path: '*', name: 'other', component: NotFound },
  // { path: '/temp', component: temp },
  { path: '/plans', name: 'plans', component: Plans },
  { path: '/billing', name: 'billing', component: Billing },
  { path: '/users', name: 'users', component: Users },
  { path: '/sent-verification', name: 'sentverification', component: SentVerification },
]

/*const routes = routerOptions.map(route => {
  console.log(route.component)
  return {
    ...route,
    component: () => import(`@/views/${route.component}.vue`)
  }
})*/

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const guest = to.matched.some(record => record.meta.guest)
  //const isAuthenticated = firebase.auth().currentUser && firebase.auth().currentUser.emailVerified
  const isAuthenticated = firebase.auth().currentUser
  if (requiresAuth && !isAuthenticated) {
    next('/signin')
  } else if (guest && isAuthenticated) {
    next('/home')
  } else {
    if(to.name=="assets" && (!['3d-model','visual-effect','character-model','character-animation','voice','sound','video','images'].includes(to.params.asset) || !to.params.asset)) next('/assets/3d-model');
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js